// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "96711e76d34e5eaef04576a8c3e673d1" + ".js";
};